import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TDisplay } from "../../../../interface/interfaces";


interface IInitialState{
    display: TDisplay;
}

const initialState: IInitialState = {
    display: 'row'
}

const dashboardListDisplaySlice = createSlice({
    name: 'dashboardListDisplay',
    initialState,
    reducers: {
        setDashboardListDisplay: (state, action: PayloadAction<TDisplay>)=>{
            state.display = action.payload;
        }
    }
})

export default dashboardListDisplaySlice.reducer;
export const {setDashboardListDisplay} = dashboardListDisplaySlice.actions;